import React, { useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom'
import { useFormContext } from "react-hook-form";
import TextField from '@material-ui/core/TextField';


const EquipeTecnicaForm = (props) => {
  const { form, onChange, children } = props;
  const { register, errors, clearError, setValue } = useFormContext();

  useEffect(() => {
    register({ name: 'ocupacaoEquipeTecnica' }, { required: 'Ocupação é obrigatório' });
    if(form.ocupacao) {
      setValue('ocupacaoEquipeTecnica', form.ocupacao);
    }
  }, [])

  return (
    <>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Ocupação"
          fullWidth
          InputLabelProps={{ shrink: true }}
          id="ocupacaoEquipeTecnica"
          name="ocupacaoEquipeTecnica"
          margin="normal"
          variant="outlined"
          defaultValue={form.ocupacao}
          onChange={onChange}
          error={!!errors?.ocupacaoEquipeTecnica}
          helperText={errors?.ocupacaoEquipeTecnica?.message}
        />

      </Grid>
      {children}
    </>
  );
}

export default withRouter(EquipeTecnicaForm);
